

module.directive('fadeText', function($animateCss) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var initialized = false,
                defaultText = element.text();

            function makeAnimation(forwards) {
                return $animateCss(element, {
                    duration: .25,
                    from: {opacity: forwards ? 1 : 0},
                    to: {opacity: forwards ? 0 : 1},
                });
            }

            attrs.$observe('fadeText', function(val) {
                if (!initialized) {
                    element.text(val || defaultText);
                    initialized = !!val;
                } else {
                    makeAnimation(true).start().done(function() {
                        element.text(val);
                        makeAnimation(false).start();
                    });
                }
            });
        },
    };
});
